import React from 'react';

import {observer} from "mobx-react";
import {MegaHeaderModuleProps} from "../models/mega-header-module.props";
import {MegaHeaderModuleDesktopContent} from "./mega-header-module.desktop.content";
import classnames from "classnames";

export class MegaHeaderModuleDesktopProps extends MegaHeaderModuleProps {}

export const MegaHeaderModuleDesktop = observer(({controller}: MegaHeaderModuleDesktopProps) => {
  const {state} = controller;

  return (
    <div className={classnames('mega-header-module-container', {visible: state.isVisible})}>
      <div className={'mega-header-module-sub-container'}>
        <MegaHeaderModuleDesktopContent controller={controller} />
      </div>
    </div>
  );
});

